// Строка поиска карты /tutors на телефоне (25.10.2026). Без импортов: модуль
// читают страница и scripts/verify-tutors-mobile.mts.

/** Поиск без учёта регистра и знаков: «Nəsimi» = «nesimi», «Şəki» = «seki», «Ёлка» = «елка». */
export function searchFold(s: string): string {
  return (
    s
      .toLowerCase()
      .replace(/[əä]/g, "e")
      .replace(/ı/g, "i")
      .replace(/ş/g, "s")
      .replace(/ç/g, "c")
      .replace(/ğ/g, "g")
      .replace(/ö/g, "o")
      .replace(/ü/g, "u")
      // ё → е кодами: буквальная кириллица в сравнениях запрещена (verify:answer-labels).
      .replace(/\u0451/g, "\u0435")
      // Остальные знаки над буквами (İ → i + точка) — снять.
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .trim()
  );
}
